<template>
    <el-form
      v-loading="saveLoading || findLoading"
      v-if="model"
      :label-position="labelPosition"
      :label-width="labelWidthForm"
      :model="model"
      :rules="rules"
      @submit.native.prevent="doSubmit"
      class="form"
      ref="form"
    >

      <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
        <el-col :lg="12" :md="16" :sm="24">
          <el-input :disabled="true" v-model="model[fields.id.name]" />
        </el-col>
      </el-form-item>

      <el-form-item
        :label="fields.name.label"
        :prop="fields.name.name"
        :required="fields.name.required"
      >
        <el-col :lg="12" :md="16" :sm="24">
          <el-input ref="focus" prefix-icon="icon-cup" :placeholder="fields.name.label" v-model="model[fields.name.name]" />
        </el-col>
      </el-form-item>

      <el-form-item
        :label="fields.label.label"
        :prop="fields.label.name"
        :required="fields.label.required"
      >
        <el-col :lg="12" :md="16" :sm="24">
          <el-input prefix-icon="icon-info" :placeholder="fields.label.label" v-model="model[fields.label.name]" />
        </el-col>
      </el-form-item>

      <el-form-item
        :label="i18n('entities.category.fields.intervalBirthYear')"
      >
        <el-row :gutter="10">
          <el-col :lg="24" :md="24" :sm="24">
            <app-date-range
              :startDate.sync="model[fields.minBirthDate.name]"
              :endDate.sync="model[fields.maxBirthDate.name]"
              :required="true"
              :startPlaceholder="i18n('entities.category.placeholders.yearStart')"
              :endPlaceholder="i18n('entities.category.placeholders.yearEnd')"
              :type="typeDatePicker"
              ref="dateRange"
            />
          </el-col>
        </el-row>
      </el-form-item>

      <!-- Form controls -->
      <el-form-item>
          <div class="form-buttons">
                <router-link :to="{path: '/subproperty/settings/program/categories'}">
                  <el-button class="cancel-button">
                      <app-i18n code="common.cancel" />
                  </el-button>
              </router-link>

              <el-button
                  :disabled="saveLoading"
                  @click="handleSubmit"
                  type="primary"
              >
                  <app-i18n v-if="!isEditing" code="common.add"/>
                  <app-i18n v-if="isEditing" code="common.save"/>
              </el-button>

          </div>
      </el-form-item>

    </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { CategoryModel } from '@modules/category/category-model';
import { i18n } from '@shared/i18n';
import 'fix-date';

export default {
  name: 'CategoryForm',

  props: {
    id: {
      type: String,
    },
    manage: {
      type: Object,
    },
    handleSubmitFn: {
      type: Function,
    },
  },

  data() {
    return {
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'category/form/record',
      findLoading: 'category/form/findLoading',
      saveLoading: 'category/form/saveLoading',
      typeDatePicker: 'auth/manage/typeDatePicker',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
      populateDate: 'auth/manage/populateDate',
    }),

    isEditing() {
      return !!this.id;
    },


    rules () {
      const { formSchema } = this
      return formSchema.rules();
    },

    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.name,
        fields.label,
        fields.minBirthDate,
        fields.maxBirthDate,
        fields.index,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat, populateDate } = this;
      return new CategoryModel({ dateFormat, timeFormat, populateDate }).fields();
    },
  },

  async created() {
    const { formSchema } = this;

    if (this.isEditing) {
      await this.doFind({
        id: this.id,
        manage: this.manage,
      });
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'category/form/doFind',
      doNew: 'category/form/doNew',
      doUpdate: 'category/form/doUpdate',
      doCreate: 'category/form/doCreate',
    }),

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(this.record);
    },
    handleSubmit() {
      if (this.handleSubmitFn) {
        this.doSubmit();
      } else {
        this.doSubmit();
      }
    },

    async doValidation() {
      try {

        const { form, dateRange } = this.$refs;
        const forms = [];
        
        if (form) forms.push(form);

        if (dateRange) { 
          forms.push(dateRange.$refs.form)
        }
        
        await Promise.all(forms.map(form => {
          form.clearValidate();
          return form.validate();
        }));
      } catch (error) {
        throw error;
      }
    },

    async doSubmit() {
      try {
        await this.doValidation();
      } catch (error) {
        return;
      }
      const { formSchema } = this;
      const { id, ...values } = formSchema.cast(this.model);
  
      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
          manage: this.manage,
        });
      } else {
        return this.doCreate({
          values,
          manage: this.manage,
        });
      }
    },
    i18n(code){
      return i18n(code)
    },
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
